import { IonButton, IonIcon, IonInput } from "@ionic/react";
import { eyeOffOutline, eyeOutline } from "ionicons/icons";

export default function PasswordField({
  label,
  value,
  onIonInput,
  placeholder,
  visible,
  onToggleVisibility,
}) {
  return (
    <div className="auth-field-wrap">
      <IonInput
        className="metora-input"
        label={label}
        labelPlacement="stacked"
        type={visible ? "text" : "password"}
        value={value}
        onIonInput={onIonInput}
        placeholder={placeholder}
      />
      <IonButton
        type="button"
        fill="clear"
        className="auth-field-action"
        aria-label={visible ? `Hide ${label}` : `Show ${label}`}
        onClick={onToggleVisibility}
      >
        <IonIcon icon={visible ? eyeOffOutline : eyeOutline} />
      </IonButton>
    </div>
  );
}
